<template>
	<BaseWebshopCart v-slot="{parcels, urls}">
		<div class="wc-selected-shippings" v-if="parcels?.length">
			<template v-for="parcel in parcels" :key="parcel.number">
				<WebshopCheckoutPanel :title="'Paket ' + parcel.number + ' od ' + parcels.length">
					<div class="wc-selected-shipping" v-if="parcel.shipping?.selected">
						<NuxtLink class="edit" :to="urls.webshop_shipping"><BaseCmsLabel code="edit" /></NuxtLink>
						<p class="selected-shipping">{{ parcel.shipping.selected.title }} <span v-if="parcel.shipping.selected.shipping_price"><BaseUtilsFormatCurrency :price="parcel.shipping.selected.shipping_price" /></span></p>
						<div class="items">
							<template v-for="item in parcel.items" :key="item.id">
								<p class="item">
									{{ item.item.title }}
								</p>
							</template>
						</div>
						<p class="info">
							<template v-if="parcel.shipping?.selected?.preorder_package == true && parcel.shipping?.selected?.min_date">predvidoma <BaseUtilsFormatDate :date="parcel.shipping.selected.min_date" /></template>
							<template v-else-if="parcel.shipping?.selected?.code == 'hitra_dostava'"><BaseCmsLabel code="wc_shipping_hitra_dostava_info" /></template>
							<template v-else>
								<template v-if="parcel.shipping?.selected?.min_date && parcel.shipping?.selected?.max_date">predvidoma od {{ formatDateLong(parcel.shipping.selected.min_date) }} do {{ formatDateLong(parcel.shipping.selected.max_date) }}</template>
							</template>
						</p>
						<div class="seller" v-if="parcel.parcel_name">
							<BaseCmsLabel code="seller_item_title" /> {{ parcel.parcel_name }}
						</div>
					</div>
				</WebshopCheckoutPanel>
			</template>
		</div>
	</BaseWebshopCart>
</template>

<script setup>
	const {formatDateLong} = useUtilsBB();
	const labels = useLabels();
</script>

<style lang="less" scoped>
	.wc-selected-shippings{display: flex; flex-direction: column; gap: 18px; font-size: 12px;}
	.selected-shipping{
		font-weight: bold;
		span{padding-left: 5px;}
	}
	p{padding: 0 0 5px;}
	.edit{position: absolute; top: 19px; right: 15px; font-size: 14px;}
	.info{
		padding: 0; color: var(--gray7);
		@media (max-width: @m){padding: 0 0 5px;}
	}
	.seller{
		position: absolute; right: 15px; bottom: 15px; color: var(--gray7);
		@media (max-width: @m){position: relative; right: auto; bottom: auto;}
	}
</style>